import type { ComponentChildren, JSX } from 'preact';
import { cn } from '@/lib/cn';

export type ResponsiveGridVariant = 'cards' | 'catalog' | 'metrics';

export interface ResponsiveGridProps extends JSX.HTMLAttributes<HTMLDivElement> {
  children: ComponentChildren;
  variant?: ResponsiveGridVariant;
}

const VARIANT_CLASS: Record<ResponsiveGridVariant, string> = {
  cards: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3',
  catalog: 'grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5',
  metrics: 'grid-cols-2 lg:grid-cols-4',
};

export function ResponsiveGrid({
  children,
  variant = 'cards',
  className,
  ...props
}: ResponsiveGridProps) {
  return (
    <div className={cn('grid auto-rows-max gap-4', VARIANT_CLASS[variant], className)} {...props}>
      {children}
    </div>
  );
}
